module.exports = __webpack_public_path__ + "static/4iiii_thumbnail-eee360ef2f22eb42a5d396bea6f5f73d.jpg";